// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {useEffect, useState} from 'react';
import {i_user_info} from 'hola_app_context';
import etask from 'zetask';
import {api} from './api';
import {use_interval} from '../ui/dashboard/utils';

export type t_kyc_status =
    'init' | 'pending' | 'pre_approved' | 'completed' | 'rejected' | 'retry';
export type t_kyc_data = {
    status: t_kyc_status;
    inited: boolean;
    token?: string;
};

export const get_kyc_status = (user: i_user_info): t_kyc_status=>{
    if (user?.kyc_approved_email)
        return 'completed';
    if (user?.kyc_pre_approved_email)
      return 'pre_approved';
    return 'init';
};

export const use_kyc = (user: i_user_info, disable_kyc = false)=>{
    const [info, set_info] = useState<t_kyc_data>(()=>({
        status: get_kyc_status(user),
        inited: false,
    }));
    const check_status = ()=>{
        if (disable_kyc)
            return;
        etask(function*(){
            if (!user)
                return;
            const data = yield api.check_kyc_status();
            if (data?.status)
            {
                set_info(val=>({...val,
                    status: data.status, inited: true}));
            }
            else
                set_info(val=>({...val, inited: true}));
        });
    };
    useEffect(()=>check_status(), []);
    const is_pending = info.status == 'pending'
        || info.status == 'pre_approved';
    use_interval(()=>{
        check_status();
    }, is_pending ? 30 : 0);
    const start_kyc_process = ()=>{
        etask(function*(){
            const response = yield api.generate_kyc_access_token();
            if (response.token)
                set_info(val=>({...val, token: response.token}));
        });
    };
    const clear_token = ()=>set_info(val=>({...val, token: null}));
    return {info, is_pending, start_kyc_process, check_status, clear_token};
};
